export default __webpack_public_path__ + "static/media/home-main-md.724f472f.jpg";